import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_text_field, {
      key: "search-input",
      class: "search-input mt-4",
      "clear-icon": "mdi-close-circle",
      clearable: "",
      label: "Search",
      modelValue: _ctx.input,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
      variant: "outlined",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFocusedInput(`search-input`))),
      "onClick:clear": _ctx.clearInput
    }, null, 8, ["modelValue", "onClick:clear"])
  ]))
}